import { render } from "./BaseBadge.vue?vue&type=template&id=b30ed512&scoped=true"
import script from "./BaseBadge.vue?vue&type=script&lang=js"
export * from "./BaseBadge.vue?vue&type=script&lang=js"

import "./BaseBadge.vue?vue&type=style&index=0&id=b30ed512&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ACER\\Desktop\\Vue Course\\Main Course Project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b30ed512"]])

export default __exports__